import moize from 'moize'
import { invert } from 'remeda'
import { z } from 'zod'

import { ItemAction } from '@jotta/grpc-web/no/jotta/openapi/file/file.v2_pb'

import { createEnum } from './schemaUtils'

export type ItemActionKey = keyof typeof ItemAction
const ItemActionObj: Record<ItemActionKey, ItemAction> = { ...ItemAction }
const ItemActionReverse: Record<ItemAction, ItemActionKey> =
  invert(ItemActionObj)
export const getItemActionKey = moize(
  (Action: ItemAction = ItemAction.UNKNOWN_FILE_ACTION): ItemActionKey =>
    ItemActionReverse[Action] || 'UNKNOWN_FILE_ACTION',
)
export const { fileActionContextSchema, isFileActionContext } = createEnum(
  'FileActionContext',
  [
    'BREADCRUMB',
    'FAB',
    'FOLDER_LIST',
    'PUBLIC_LINKS',
    'SELECTION',
    'PENDING_INVITE_LISTITEM',
  ],
)
export const FileActionSchema = z.enum([
  'ADD_CHILD',
  'COPY',
  'CREATE_DOCUMENT',
  'CREATE_FOLDER',
  'CREATE_PRESENTATION',
  'CREATE_SPREADSHEET',
  'DELETE',
  'DISPLAY_REVISIONS',
  'DOWNLOAD',
  'RENAME',
  'MOVE',
  'SHARE',
  'UPLOAD_FILES',
  'UPLOAD_FOLDER',
  'PERMANENTLY_DELETE',
  'PUBLIC_SHARE',
  'PUBLIC_UNSHARE',
  'RESTORE',
  'UNKNOWN_FILE_ACTION',
  'UPDATE',
  'PENDING_INVITE_ACCEPT',
  'PENDING_INVITE_DECLINE',
])
